import React from 'react';
import Dropzone from 'react-dropzone';
import servicioCfdi from '../servicios/ServicioCfdi'
import { Button } from 'primereact/button';
import { Messages } from 'primereact/messages';
export class SubirCfdi extends React.Component {
  constructor() {
    super();
    this.state = {
      files: [],
      files2: [],
      archivos: [],
      ttCfdi: {},
      errores: []
    };
    this.guardar = this.guardar.bind(this);
  }
  onDrop = (files) => {
    let formData = new FormData();
    for (var i = 0; i < files.length; i++) {
      var cfdi = files[i];
      formData.append('recibos', cfdi);
    }
    this.setState({ files2: formData });
    this.setState({ files });
  };

  guardar() {
    this.messages.clear();
    const { files2 } = this.state;
    servicioCfdi.procesarCfdis(files2).then((response) => {
      if (response.data.objeto.errores.length > 0) {
        for (var i = 0; i < response.data.objeto.errores.length; i++) {
          var valor = response.data.objeto.errores[i];
          this.messages.show({ severity: 'error', summary: 'Error', detail: valor, sticky: true });
        }
      }

      if (response.data.objeto.exitos.length > 0) {
        for (var i = 0; i < response.data.objeto.exitos.length; i++) {
          var valor = response.data.objeto.exitos[i];
          this.messages.show({ severity: 'success', summary: 'Éxito', detail: valor, sticky: true });
        }
      }




      this.setState({ files2: [] });
      this.setState({ files: [] });
    }).catch((error) => {

    });
  }

  render() {
    const files = this.state.files.length;
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="card">
            <div className="card-title">Cargar recibos de nómina</div>
            <p>Es esta sección usted puede cargar los recibos de nómina de los trabajadores.</p>
          </div>
        </div>
        <div className="p-col-12">
          <div className="card">
            <Messages ref={(el) => this.messages = el}></Messages>
            <br></br>

            <Dropzone accept=".xml" onDrop={this.onDrop}>
              {({ getRootProps, getInputProps }) => (
                <section >
                  <div  {...getRootProps({ className: 'dropzone rectangulo' })}>
                    <input   {...getInputProps()} />
                    <center><p>Arrastra tus recibos de nómina aquí</p></center>
                  </div>
                  <br></br>
                  <Button label="Guardar Cfdis" onClick={this.guardar} />
                  <aside>
                    <h4>Cantidad de archivos a procesar</h4>
                    <ul>{files}</ul>
                  </aside>

                </section>
              )}
            </Dropzone>
          </div>
        </div>
      </div>
    );
  }
}